import React, { useState } from "react";
import PropTypes from "prop-types";
import "./Accordion.css";
import IconAccordionUp from "../../../../assets/icon_chevron_smaller_up.svg";
import IconAccordionDown from "../../../../assets/icon_chevron_smaller_down.svg";

/**
 * Accordion 컴포넌트
 * @param title
 * @param children
 * @param initialOpen
 * @param titleStyle
 * @param isOpen
 * @param onToggle
 * @param type
 * @returns {Element}
 * @constructor
 */
const Accordion = ({
  title,
  children,
  initialOpen = false,
  titleStyle,
  isOpen: controlledIsOpen,
  onToggle,
  type = "main", // "main" | "sub" (default: main)
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(initialOpen);
  const isControlled = controlledIsOpen !== undefined;
  const isOpen = isControlled ? controlledIsOpen : uncontrolledOpen;

  const handleToggle = () => {
    if (isControlled && onToggle) {
      onToggle();
    } else {
      setUncontrolledOpen((prev) => !prev);
    }
  };

  // 스타일 클래스 분기
  const headerClass = `Accordion-header Accordion-header--${type}`;
  const titleClass = `Accordion-title Accordion-title--${type}`;

  return (
    <div className={`Accordion ${isOpen ? "open" : ""}`}>
      <div className={headerClass} onClick={handleToggle}>
        <span className={titleClass} style={titleStyle}>
          {title}
        </span>
        <span className={`Accordion-icon ${isOpen ? "rotate" : ""}`}>
          {isOpen ? (
            <img src={IconAccordionUp} alt={"닫기"} />
          ) : (
            <img src={IconAccordionDown} alt={"열기"} />
          )}
        </span>
      </div>
      {isOpen && <div className="Accordion-content">{children}</div>}
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  initialOpen: PropTypes.bool,
  titleStyle: PropTypes.object,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  type: PropTypes.oneOf(["main", "sub"]),
};

export default Accordion;
